export const ConflictSeverity = {
    CRITICAL: 'CRITICAL',
    HIGH: 'HIGH',
    WARNING: 'WARNING',
    INFO: 'INFO',
};
/** Значення в порядку оголошення в схемі. */
export const CONFLICT_SEVERITY_VALUES = ['CRITICAL', 'HIGH', 'WARNING', 'INFO'];
export const CONFLICT_SEVERITY_LABELS = {
    CRITICAL: 'Критичний',
    HIGH: 'Високий',
    WARNING: 'Попередження',
    INFO: 'Інформація',
};
export const CONFLICT_SEVERITY_TONES = {
    CRITICAL: 'danger',
    HIGH: 'warning',
    WARNING: 'info',
    INFO: 'neutral',
};
//# sourceMappingURL=conflict-severity.js.map